module.exports = __webpack_public_path__ + "static/media/liveannouncment.7cee0c73.svg";